import { render, staticRenderFns } from "./PermissionDeniedOverlay.vue?vue&type=template&id=2a1a83f6&scoped=true"
import script from "./PermissionDeniedOverlay.vue?vue&type=script&lang=js"
export * from "./PermissionDeniedOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1a83f6",
  null
  
)

export default component.exports